import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";

import { ReactComponent as DownArrow } from "../assets/icons/down-arrow.svg";
import { ReactComponent as Close } from "../assets/icons/close.svg";

import "react-datepicker/dist/react-datepicker.css";
import { de } from "date-fns/locale";

interface IVmVCalenderProps {
  date: Date | null;
  handleChangeDate: (date: any) => void;
}

registerLocale("de", de);
const VmVCalender = ({
  date,
  handleChangeDate,
}: IVmVCalenderProps): JSX.Element => {
  setDefaultLocale("de");
  const { t } = useTranslation();

  return (
    <div className="calender_container">
      <DatePicker
        // showIcon
        // selectsRange
        // isClearable
        locale="de"
        minDate={new Date("4/1/2025")}
        maxDate={new Date("7/1/2025")}
        fixedHeight
        dateFormat="dd/MM/yyyy"
        placeholderText={t("components.datePicker.placeHolderAllDates")}
        selected={date}
        onChange={(selectedDate) => {
          handleChangeDate(selectedDate);
        }}
      />
      {date !== null ? (
        <Close
          onClick={() => {
            handleChangeDate(null);
          }}
          width={30}
          height={30}
        />
      ) : (
        <DownArrow width={20} height={20} />
      )}
    </div>
  );
};

export default VmVCalender;
